import React, { useState } from 'react'
import { HiInformationCircle } from 'react-icons/hi';
import Skeleton from 'react-loading-skeleton';

const ServiceCard = ({e,chooseTime}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleCard = () => {
      setIsExpanded(!isExpanded);
    };



    
    return (
        <>
            <div className="col-md-3">
                {/* <div className="service_card "> */}
                <input type="checkbox" id={e?.id} name="Wash cut and Style" value={e?.id} />
                <label for="Wash cut and Style" className='label-button' onClick={toggleCard}>
                    <div className='icon'>
                        <HiInformationCircle style={{ color: '#007BFF', fontSize: '26px' }} />
                    </div>
                    <h4 className='mb-2'>{e?.title || <Skeleton />}</h4>
                    <h6 className='mb-2'>{e?.duration || <Skeleton />} min</h6>
                    <h4 className='mb-2'>$ {e?.price || <Skeleton />}</h4>



                    {isExpanded ?
                        <>
                            <h4 className='mb-2'>{e?.description}</h4>
                            <button className='btn btn-ouline-light' onClick={() => chooseTime(e?.id,e?.duration)}>Book</button>
                        </>
                        :
                        <button className='btn btn-ouline-light' onClick={() => chooseTime(e?.id,e?.duration)}>Book</button>
                    }
                </label>
            </div>
        </>
    )
}

export default ServiceCard